import { StablecoinLatestDO } from "./pie-chart.models";

interface PieDO {
    [key: string]: number
}

class PieChartTransform {
    public jurisdictionMarketCapsToPieDO(data: StablecoinLatestDO): PieDO {
        return data.jurisdiction_market_caps || {};
    }

    public domiciliationMarketCapsToPieDO(data: StablecoinLatestDO): PieDO {
        return data.domiciliation_market_caps || {};
    }

    public stablecoinsSupplyBySectorToPieDO(data: StablecoinLatestDO): PieDO {
        return data.stablecoins_supply_by_sector || {};
    }

    public stablecoinMarketValuePerPeggedAssetToPieDO(data: StablecoinLatestDO): PieDO {
        return data.stablecoin_market_value_per_pegged_asset || {};
    }
}

export const pieChartTransform = new PieChartTransform() 